var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result"},[(_vm.type == 2)?_c('random',{attrs:{"id":_vm.testid,"type":_vm.type}}):_vm._e(),(_vm.type == 3)?_c('dimensionality',{attrs:{"id":_vm.testid,"type":_vm.type}}):_vm._e(),(_vm.type == 1)?_c('grade',{attrs:{"id":_vm.testid,"type":_vm.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }